import { CHANNEL_NAME } from './protocol';

// Same-origin message transport between the publisher tabs and the display
// window. BroadcastChannel when available; otherwise a localStorage "storage"
// event fallback (older Safari). Neither path touches the backend.

const STORAGE_KEY = CHANNEL_NAME + ':message';

function randomNonce() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

export function createTransport(win) {
  const w = win || (typeof window !== 'undefined' ? window : null);
  const listeners = [];
  const emit = (message) => listeners.slice().forEach((fn) => fn(message));

  if (w && typeof w.BroadcastChannel === 'function') {
    const channel = new w.BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event) => emit(event.data);
    return {
      kind: 'broadcast-channel',
      post: (message) => channel.postMessage(message),
      subscribe(fn) {
        listeners.push(fn);
        return () => listeners.splice(listeners.indexOf(fn), 1);
      },
      close: () => channel.close()
    };
  }

  const onStorage = (event) => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try {
      emit(JSON.parse(event.newValue).message);
    } catch (error) {
      // Ignore malformed payloads.
    }
  };
  if (w) w.addEventListener('storage', onStorage);
  return {
    kind: 'storage-event',
    post(message) {
      try {
        // A fresh nonce guarantees a change event even for identical messages.
        w.localStorage.setItem(STORAGE_KEY, JSON.stringify({ nonce: randomNonce(), message }));
      } catch (error) {
        // Storage unavailable: nothing else we can do.
      }
    },
    subscribe(fn) {
      listeners.push(fn);
      return () => listeners.splice(listeners.indexOf(fn), 1);
    },
    close: () => w && w.removeEventListener('storage', onStorage)
  };
}
